"use client";

import {
  spacing,
  colors,
  fontSizes,
} from "@softmax/design-system/tokens.stylex";

import type { EpisodeSort } from "./episode-values";
import * as stylex from "@stylexjs/stylex";
import { Select } from "@softmax/design-system";

export function SortSelect({
  sort,
  onChange,
}: {
  readonly sort: EpisodeSort;
  readonly onChange: (sort: EpisodeSort) => void;
}) {
  return (
    <div {...stylex.props(localStyles.sorting)}>
      <span>Sort</span>
      <Select
        aria-label="Sort episodes"
        value={sort}
        onValueChange={onChange}
        options={[
          { value: "newest", label: "Newest" },
          { value: "score", label: "Highest score" },
        ]}
      />
    </div>
  );
}

const localStyles = stylex.create({
  sorting: {
    display: "flex",
    alignItems: "center",
    gap: spacing.space8,
    marginLeft: "auto",
    fontSize: fontSizes.caption,
    color: colors.muted,
  },
});
